import Axios from 'axios'
import {facilityAllocationUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_allocations (context) {
    Axios.get(facilityAllocationUrls.getAllFacilityAllocations).then(function (response) {
      context.commit('GET_FACILITY_ALLOCATIONS', response.data)
    })
  },

  post_facility_allocation (context, data) {
    Axios.post(facilityAllocationUrls.postFacilityAllocation, data).then(function () {
      context.dispatch('get_all_facility_allocations')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
 
  update_facility_allocation (context, data) {
    Axios.patch(facilityAllocationUrls.editFacilityAllocation, data).then(function () {
      context.dispatch('get_all_facility_allocations')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_facility_allocation(context, data) {
    Axios.post(facilityAllocationUrls.deleteFacilityAllocation + data.public_id, data).then(function (response) {
      context.commit('GET_DELETED_FACILITY_ALLOCATIONS', response.data)
      context.dispatch('get_all_facility_allocations')
    })
  }

}
